import React from "react"
import { TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn, FontIcon } from "material-ui"
import Table from "../../../../components/common/Table"
import strings from "../../../../localization/strings"
import { green500 } from "material-ui/styles/colors"
import { IClientContactDocument } from "../../../../models"
interface IProps {
    readonly: boolean
    clientContacts: IClientContactDocument[]
    selectedClientContacts: IClientContactDocument[]
    offset: number
    limit: number
    limitOptions: number[]
    total: number
    handleSelect(selectedClientContacts: IClientContactDocument[]): void
    handleUpdate(editClientContact: IClientContactDocument): void
    onPageClick(offset: number): void
    onLimitChange(limit: number): void
}

const ClientContactTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            {props.clientContacts.length === 0 ?
                <div>
                    <h2 style={{ textAlign: "center", marginTop: 25 }}>{strings.No_contact_found}</h2>
                </div> :
                <Table
                    readonly={props.readonly}
                    allowClickRow
                    items={props.clientContacts}
                    handleClickRow={clientContact => props.handleUpdate(clientContact)}
                    handleSelect={selectedClientContacts => props.handleSelect(selectedClientContacts)}
                    total={props.total}
                    offset={props.offset}
                    limit={props.limit}
                    limitOptions={props.limitOptions}
                    onPageClick={props.onPageClick}
                    onLimitChange={props.onLimitChange}
                >
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.First_Name}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Last_Name}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Phone}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Email}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Title}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Primary}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Billing}</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: "center" }}>{strings.Active}</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover={true} deselectOnClickaway={false}>
                        {props.clientContacts.map(contact =>
                            <TableRow
                                key={contact.Id}
                                selected={props.selectedClientContacts.find(item => item.Id === contact.Id) ? true : false}
                            >
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{contact.FirstName}</TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{contact.LastName}</TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{contact.ContactInfo && contact.ContactInfo.MobilePhone && contact.ContactInfo.MobilePhone.PhoneNumber}</TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{contact.ContactInfo && contact.ContactInfo.PrimaryEmail && contact.ContactInfo.PrimaryEmail.Email}</TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{contact.Title}</TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
                                    {contact.Primary &&
                                        <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
                                    {contact.Billing &&
                                        <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                                    }
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
                                    {contact.Active &&
                                        <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                                    }
                                </TableRowColumn>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            }
        </div>
    )
}

export default ClientContactTable